import React, { useState } from "react";
import signOutWarning from "../../Common/signOutWarning";
import { copyConfirmText } from "../../Common/aiDisclaimer";
import LoginModal from "../modals/LoginModal";
import AiDialog from "../modals/AiDialog";
// Old Build Trip with AI planner, unhooked 2026-10-19 (Build My Trip stage 4:
// every AI trip now goes through Build My Trip's AI source). Its file is kept;
// restore this import (and remove the stub) to bring it back.
// import TripAI from "../modals/TripAI";
import AlertModal from "../modals/AlertModal";
// import GuideInfo from "../modals/GuideInfoXXX";
import "./VerticalSidebar.css";
import { AUTHORIZATION_LEVEL } from "../../Common/Common";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../store/reducer";
import { useSelector } from "react-redux";
import Guide, { GuideAttributes } from "../../Models/Guide";
import DataBase from "../../dataBase/liquidGuides";
import GuideSettingsDialog from "../modals/GuideSettingsDialog";
import GuideEditModal from "../modals/GuideEditModal";
import ImageDialog from "../modals/ImageDialog";

import { DateTime } from "luxon";
import useInvitationCount from "../../Common/useInvitationCount";
// Stand-in for the unhooked old Build Trip with AI planner (see the
// commented import above).
const TripAI = () => null;

const VerticalSidebar = () => {
  const [ShowLoginModal, setShowLoginModal] = useState(false);
  const [LoginModalMode, setLoginModalMode] = useState("Login");
  const [AiDialogShow, setAiDialogShow] = useState(null);
  const [TripAIShow, setTripAIShow] = useState(null);

  const [AlertModalShow, setAlertModalShow] = useState(false);
  const [AlertModalTitle, setAlertModalTitle] = useState("");
  const [AlertModalMessage, setAlertModalMessage] = useState("");
  const [AlertModalButtons, setAlertModalButtons] = useState([]);
  const [GuideSettingsDialogShow, setGuideSettingsDialogShow] = useState(false);
  const [GuideEditModalShow, setGuideEditModalShow] = useState(false);
  const [GuideEditModalMode, setGuideEditModalMode] = useState("VIEW");
  const [ImageDialogShow, setImageDialogShow] = useState(false);

  const dispatch = useDispatch();
  let GuidesOrPlaces = useSelector((state) => state.GuidesOrPlaces);
  let AppSettings = useSelector((state) => state.AppSettings);
  let Authorization = useSelector((state) => state.Authorization);
  let user_info = useSelector((state) => state.user_info);
  const inviteCount = useInvitationCount(user_info?.uid);
  let guide_meta = useSelector((state) => state.guide_meta);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let GuideStack = useSelector((state) => state.GuideStack);
  let ScheduleName = useSelector((state) => state.ScheduleName);
  let ScheduleNames = useSelector((state) => state.ScheduleNames);
  let imageFolder = useSelector((state) => state.imageFolder);

  const ShowGuidesOrGuide = (guides_or_places, GuideType) => {
    let temp = guides_or_places === "Guides" ? "Places" : "Guides";
    if (guides_or_places === GuidesOrPlaces) {
      ShowGuidesOrGuideTimeout(temp, GuideType);
      setTimeout(() => ShowGuidesOrGuideTimeout(guides_or_places, GuideType), 100);
    } else ShowGuidesOrGuideTimeout(guides_or_places, GuideType);
  };
  const ShowGuidesOrGuideTimeout = (guides_or_places, GuideType) => {
    let Hide = guides_or_places === "Guides" ? true : false;
    dispatch(slice1Actions.setGuidesOrPlaces({ value: guides_or_places, GuideType: GuideType }));
    //window.GuidesOrPlaces = newValue;
    dispatch(slice1Actions.setHideSchedule({ value: Hide }));
    if (guides_or_places === "Guides") {
      dispatch(slice1Actions.setHideMap({ value: false }));
      dispatch(slice1Actions.setHidePlaces({ value: false }));
      //ShowSelectGuide();
    } else {
      dispatch(slice1Actions.resetHomeScreen({ value: null }));
    }
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
    //setTimeout(updateMap, 1000);
  };

  const newGuide = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot create new guides in guest mode. You must be registered and logged in", "Message");
      return;
    }
    myConfirm("This will create a new guide. Save any wanted changes to this guide first. Continue?", [
      { Title: "OK", Method: () => _newGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _newGuide = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    let new_guide_attributes = new GuideAttributes("New Guide", "", null, "English", 0, [], []);
    newGuideCallback(new_guide_attributes);
    dispatch(slice1Actions.setHideSchedule({ value: false }));
  };

  let _attributes = null;
  const newGuideCallback = (guideAttributes) => {
    _attributes = guideAttributes;
    let GuideObj = new Guide("new");
    GuideObj.decodeGuideFb(GuideObj, _attributes);
    GuideObj.user_id = user_info.uid;
    DataBase.batchedWriteGuide(GuideObj, null, null, user_info, "new", addGuideDataCallbackNewGuide);
  };

  const addGuideDataCallbackNewGuide = (res) => {
    if (res.pass !== true) {
      dispatch(slice1Actions.SetLoadingGuide({ value: false }));
      return;
    }
    window.record_last_guide_read = true;
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
  };

  // Silent (no confirm dialog), awaitable-via-callback guide creation, with
  // an optional custom name — used by TripAI's "Create new guide" option to
  // fold the previously-separate "create a blank guide, then come back and
  // create the trip" flow into one continuous action.
  const createNewGuideForAI = (name, callback) => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot create new guides in guest mode. You must be registered and logged in", "Message");
      callback(false);
      return;
    }
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    const attributes = new GuideAttributes(name || "New Guide", "", null, "English", 0, [], []);
    let GuideObj = new Guide("new");
    GuideObj.decodeGuideFb(GuideObj, attributes);
    GuideObj.user_id = user_info.uid;
    DataBase.batchedWriteGuide(GuideObj, null, null, user_info, "new", (res) => {
      if (res.pass !== true) {
        dispatch(slice1Actions.SetLoadingGuide({ value: false }));
        callback(false);
        return;
      }
      window.record_last_guide_read = true;
      DataBase.readGuideTransaction(res.new_info_ref.id, (res2) => {
        readGuideDataReturnNew(res2);
        dispatch(slice1Actions.setHideSchedule({ value: false }));
        callback(true);
      }, user_info.uid);
    });
  };

  const readGuideDataReturnNew = (res) => {
    let GuideObj = null;
    if (res.pass === true) {
      GuideObj = new Guide(res.guide_id);
      const guide_json = res.res.data;
      console.log(`Guide Size is: ${guide_json.length}`);
      let guide_obj;
      try {
        guide_obj = JSON.parse(guide_json);
      } catch (e) {
        console.error("Failed to parse guide JSON", e);
        dispatch(slice1Actions.SetLoadingGuide({ value: false }));
        return;
      }
      const decoded = GuideObj.decodeGuideFb(guide_obj, res.infoDoc);
      if (decoded === true) {
        GuideObj.schedule.getPlaces_InSchedule();
        window.guide_obj = GuideObj;
        dispatch(
          slice1Actions.setGuide({
            guide: "new",
            guide_meta: { guide_info: res.infoDoc, guide_info_id: res.guide_info_id, guide_id: res.guide_id },
          })
        );
        dispatch(slice1Actions.setCreatorInfo({ value: res.creator_info }));
        dispatch(slice1Actions.setOwnerInfo({ value: res.owner_info }));
        dispatch(slice1Actions.pushGuideStack({ value: res.guide_info_id }));
        dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
        setTimeout(fitPlaces, 1000);
        if (window.record_last_guide_read === true && user_info.uid !== "guest") {
          window.record_last_guide_read = false;
          recordLastGuideRead(res.guide_info_id);
        }
        // dispatch(slice1Actions.setGuideInfo({ value: res.infoDoc }));
        // dispatch(slice1Actions.setAuthorization({ guide_info: res.infoDoc, uid: user_info.uid }));
        //dispatch(slice1Actions.setOwnerInfo({ value: res.user_info }));
        //console.log(res.owner_info);
      } else {
        console.log("decode failed");
      }
    } else {
      //console.log(res.res);
    }
    window.record_last_guide_read = false;
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const fitPlaces = (user) => {
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };

  const recordLastGuideRead = (guide_info_id) => {
    // Guests have no cloud user profile to persist this to — DataBase's
    // guest guard would reject the write anyway, but with an intrusive
    // "Guest Mode / Saving to the cloud..." alert, which is wrong here: this
    // is passive background bookkeeping (remembering the last guide viewed)
    // that fires on every guide load, not something the user asked to save.
    if (user_info === null || user_info.uid === "guest") return;
    let _user_info = JSON.parse(JSON.stringify(user_info));
    _user_info.last_guide_id = guide_info_id;
    _user_info.last_guide_time = DateTime.utc().toISO();
    dispatch(slice1Actions.setUserInfo({ value: _user_info }));
    DataBase.updateUser(_user_info, _user_info.uid, updateUserCallback);
  };

  const updateUserCallback = (res) => {
    console.log("updateUserCallback", res.pass);
  };

  const timeoutFunc = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
  };

  const copyGuide = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot copy guides in guest mode. You must be registered and logged in");
      return;
    }
    if (window.guide_obj.isAuthorized(Authorization, AUTHORIZATION_LEVEL.COPY) === false) {
      myAlert("You are not authorized to copy this guide");
      return;
    }
    myConfirm(
      copyConfirmText(window.guide_obj?.attributes),
      [
        { Title: "OK", Method: () => _batchedCopyGuide() },
        { Title: "CANCEL", Method: null },
      ]
    );
  };

  let _copiedGuideID = null;

  const _batchedCopyGuide = () => {
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    _copiedGuideID = window.guide_obj.guide_id;
    DataBase.batchedWriteGuide(window.guide_obj, null, null, user_info, "copy", batchCopyGuideCallback);
  };

  const batchCopyGuideCallback = (res) => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (res.pass !== true) {
      myAlert(res.tooLarge ? res.res : "Error copying guide");
      return;
    }
    // this.setState({
    //   new_guide_id: res.new_doc_ref.id,
    //   new_guide_info: res.new_info_ref.id,
    //   guide_info_id: res.new_info_ref.id,
    // });
    window.record_last_guide_read = true;
    DataBase.readGuideTransaction(res.new_info_ref.id, readGuideDataReturnNew, user_info.uid);
    DataBase.incrementCopiesTransaction(_copiedGuideID, incrementCopiesTransaction);
  };

  const incrementCopiesTransaction = () => {};

  const EditGuideInfo = () => {
    setGuideEditModalMode("VIEW");
    setGuideEditModalShow(true);
  };

  const myAlert = (message, title, buttons) => {
    setAlertModalMessage(message);
    setAlertModalTitle(title == null ? "Notice" : title);
    setAlertModalButtons(buttons == null ? [{ Title: "OK", Method: null }] : buttons);
    setAlertModalShow(true);
  };

  const myConfirm = (message, buttons) => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage(message);
    setAlertModalButtons(buttons);
    setAlertModalShow(true);
  };

  const GuideEditModalCallback = (guide_attributes, edit_mode) => {
    if (edit_mode === true) {
      setGuideEditModalMode("UPDATE");
      setGuideEditModalShow(true);
      return;
    }
    if (GuideEditModalMode === "UPDATE")
      dispatch(slice1Actions.setGuide({ guide: null, update_guide_attributes: true }));
  };

  const login = () => {
    setLoginModalMode("Login");
    setShowLoginModal(true);
  };

  const logout = () => {
    setAlertModalTitle("Confirmation");
    setAlertModalMessage("Do you want to log out?" + signOutWarning());
    setAlertModalButtons([
      { Title: "YES", Method: _logout },
      { Title: "NO", Method: _logout },
    ]);
    setAlertModalShow(true);
  };

  const _logout = (resp) => {
    if (resp !== "YES") return;
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    DataBase.Logout(logoutCallback);
  };

  const logoutCallback = (res) => {
    dispatch(slice1Actions.SetLoadingGuide({ value: false }));
    if (res.pass === true) {
      const user_info = {
        distance_unit: "kilometers",
        date_format: "Month first",
        edit_mode: false,
        email: "guest@gmail.com",
        first_name: "guest",
        last_name: "user",
        uid: "guest",
        create_date: "",
        modify_date: "",
        travel_payouts_marker: "",
      };
      dispatch(slice1Actions.setUserInfo({ value: user_info }));
      dispatch(slice1Actions.setUserInfoId({ value: null }));
      //dispatch(slice1Actions.setAuthorization({ guide_info: guide_info, uid: user_info.uid }));
    }
  };

  const PreviousGuide = () => {
    if (GuideStack.length < 1) {
      dispatch(slice1Actions.clearGuideStack());
      return;
    }
    if (GuideStack.length < 2) return;
    let guide_id = GuideStack[GuideStack.length - 2];
    dispatch(slice1Actions.popGuideStack({ value: null }));
    loadGuide(guide_id);
  };

  function loadGuide(guide_info_id) {
    window.record_last_guide_read = true;
    dispatch(slice1Actions.SetLoadingGuide({ value: true }));
    setTimeout(timeoutFunc, 5000);
    DataBase.readGuideTransaction(guide_info_id, readGuideDataReturnNew, user_info.uid);
  }

  const ImageDialogCallback = (res) => {
    console.log("ImageDialogCallback", res);
  };

  const ImageUpload = () => {
    if (Authorization === AUTHORIZATION_LEVEL.GUEST) {
      myAlert("Cannot upload images in guest mode. You must be registered and logged in", "Message");
      return;
    }
    setImageDialogShow(true);
  };

  const RefreshGuide = () => {
    myConfirm("Reload this Guide from cloud? This will overwrite any changes.", [
      { Title: "OK", Method: () => _RefreshGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _RefreshGuide = () => {
    loadGuide(guide_meta.guide_info_id);
  };

  const handleChooseSchedule = () => {
    dispatch(slice1Actions.setMultiselectCallback({ value: chooseScheduleCallBack }));
    dispatch(slice1Actions.setMultiselectItems({ value: ScheduleNames }));
    dispatch(slice1Actions.setMultiselectSelectedItems({ value: ScheduleName }));
    dispatch(slice1Actions.setMultiselectMode({ value: "uni" }));
    dispatch(slice1Actions.setMultiselectSearchText({ value: "" }));
    dispatch(slice1Actions.setMultiselectTitle({ value: "Select Schedule" }));
    dispatch(slice1Actions.setShowMultiselect({ value: true }));
  };

  const chooseScheduleCallBack = (schedules) => {
    if (schedules.length > 0) {
      dispatch(slice1Actions.setScheduleName({ value: schedules[0].label }));
      dispatch(slice1Actions.setGuide({ guide: null }));
    }
  };

  const SetScheduleName = (scheduleName) => {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.setScheduleName({ value: scheduleName }));
    dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: scheduleName }] }));
    dispatch(slice1Actions.setGuide({ guide: null }));
  };

  const updateGuide = () => {
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true, update_guide_attributes: true }));
    //dispatch(slice1Actions.resetHomeScreen({ value: null }));
  };

  const updateUI = (scheduleName) => {
    if (scheduleName !== null) {
      dispatch(slice1Actions.ClearAllFilters());
      dispatch(slice1Actions.setScheduleName({ value: scheduleName }));
      dispatch(slice1Actions.SetSchedulesFilter({ value: [{ label: scheduleName }] }));
    }
    dispatch(slice1Actions.resetHomeScreen({ value: null }));
    dispatch(slice1Actions.setGuide({ guide: null, fitToBounds: true }));
  };
  
  const clearGuide = () => {
    myConfirm("This will clear the content of the current guide. The changes will be local until you save the guide. You can also refresh the guide to read the content last saved to the cloud. Continue?", [
      { Title: "OK", Method: () => _clearGuide() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  const _clearGuide = () => {
    dispatch(slice1Actions.ClearAllFilters());
    dispatch(slice1Actions.SetSearchText({ value: "" }));
    dispatch(slice1Actions.setGuide({ action: "clear" }));
  };

  const setImageFolder = (folder) => {
    dispatch(slice1Actions.setImageFolder({ value: folder }));
  };

  const isGuest = user_info.uid === null || user_info.uid === "guest" || Authorization === AUTHORIZATION_LEVEL.GUEST;
  return (
    <>
      <div className="vs-shell">

        <nav className="vs-nav">

          {/* Browse */}
          <div className="vs-group">
            <div className="vs-group-label">Library</div>
            <button className="vs-item" onClick={() => ShowGuidesOrGuide("Guides", "Mine")}>
              My Guides
            </button>
            <button className="vs-item" onClick={() => ShowGuidesOrGuide("Guides", "Featured")}>

              Featured Guides
            </button>
            <button className="vs-item" onClick={() => ShowGuidesOrGuide("Guides", "Shared")}>

              Shared Guides{inviteCount > 0 ? ` (${inviteCount} new)` : ""}
            </button>
            <button className="vs-item" onClick={() => ShowGuidesOrGuide("Places", "Featured")}>

              Current Guide
            </button>
          </div>

          {/* AI */}
          <div className="vs-group">
            <div className="vs-group-label">AI</div>
            <button className="vs-item accent" onClick={() => setAiDialogShow(true)}>

              Ask Wizard
            </button>
            {/* Build My Trip with the AI source (2026-10-19, stage 4); was
                onClick={() => setTripAIShow(true)} — the old TripAI dialog. */}
            <button className="vs-item accent" onClick={() => window.dispatchEvent(new CustomEvent("openBuildTripWithAI"))}>

              AI Guide Creator
            </button>
          </div>

          {/* Navigate */}
          <div className="vs-group">
            <button className="vs-item" onClick={() => dispatch(slice1Actions.resetHomeScreen({ value: null }))}>

              Home Screen
            </button>
            {GuideStack.length > 1 && (
              <button className="vs-item" onClick={() => PreviousGuide()}>
  
                Previous Guide
              </button>
            )}
          </div>

          {/* Guide actions */}
          <div className="vs-group">
            <div className="vs-group-label">Guide</div>
            <button className="vs-item" onClick={() => RefreshGuide()}>

              Refresh
            </button>
            <button className="vs-item" onClick={() => newGuide()}>

              New Guide
            </button>
            <button className="vs-item" onClick={() => copyGuide()}>

              Copy Guide
            </button>
          </div>

          {/* Configure */}
          <div className="vs-group">
            {ScheduleNames.length > 1 && (
              <button className="vs-item" onClick={() => handleChooseSchedule()}>
  
                Choose Schedule
              </button>
            )}
            <button className="vs-item" onClick={() => setGuideSettingsDialogShow(true)}>

              Guide Settings
            </button>
            <button className="vs-item" onClick={() => EditGuideInfo()}>

              Guide Properties
            </button>
            <button className="vs-item" onClick={() => ImageUpload()}>

              Image Upload
            </button>
          </div>

        </nav>

        {/* Auth footer */}
        <div className="vs-footer">
          {isGuest ? (
            <button className="vs-item login" onClick={() => login()}>

              Sign In
            </button>
          ) : (
            <button className="vs-item logout" onClick={() => logout()}>

              Sign Out
            </button>
          )}
        </div>

      </div>
      {AiDialogShow ? (
        <AiDialog
          show={AiDialogShow}
          onHide={() => setAiDialogShow(false)}
          questions={AppSettings.questions2}
          user_info={user_info}
        />
      ) : null}
      {TripAIShow ? (
        <TripAI
          show={TripAIShow}
          onHide={() => setTripAIShow(false)}
          user_info={user_info}
          update_ui={updateUI}
          update_guide={updateGuide}
          set_schedule_name={SetScheduleName}
          ai_base_categories={AppSettings.AIBaseCategories}
          ai_categories={AppSettings.AICategories}
          clear_guide={clearGuide}
          new_guide={newGuide}
          create_new_guide={createNewGuideForAI}
          authorization={Authorization}
          GuideSettings={GuideSettings}

          //guide_attributes={guide_meta.guide_attributes}
        />
      ) : null}
      {AlertModalShow ? (
        <AlertModal
          show={AlertModalShow}
          onHide={() => setAlertModalShow(false)}
          AlertModalTitle={AlertModalTitle}
          AlertModalMessage={AlertModalMessage}
          AlertModalButtons={AlertModalButtons}
        />
      ) : null}
      {GuideSettingsDialogShow ? (
        <GuideSettingsDialog show={GuideSettingsDialogShow} onHide={() => setGuideSettingsDialogShow(false)} />
      ) : null}
      {GuideEditModalShow ? (
        <GuideEditModal
          show={GuideEditModalShow}
          onHide={() => setGuideEditModalShow(false)}
          guide_meta={guide_meta}
          guide_info={guide_meta.guide_info}
          guide_info_id={guide_meta.guide_info_id}
          user_info={user_info}
          mode={GuideEditModalMode}
          callback={GuideEditModalCallback}
          folder={imageFolder}
          setImageFolder={setImageFolder}
        />
      ) : null}
      {ShowLoginModal ? (
        <LoginModal show={ShowLoginModal} onHide={() => setShowLoginModal(false)} mode={LoginModalMode} />
      ) : null}
      {ImageDialogShow ? (
        <ImageDialog
          show={ImageDialogShow}
          onHide={() => setImageDialogShow(false)}
          user_info={user_info}
          callback={ImageDialogCallback}
          mode={"upload"}
          modify_only={"true"}
          updateImage={ImageDialogCallback}
          size={"sm"}
          multi={true}
          exif={false}
          folder={imageFolder}
          setImageFolder={setImageFolder}
        />
      ) : null}
      {/* <GuideInfo show={guideInfoModal} onHide={() => setGuideInfoModal(false)} /> */}
    </>
  );
};

export default VerticalSidebar;
